import * as React from 'react';
import * as classnames from 'classnames';
import { Button } from '@salesforce/design-system-react';
import { Col, Grid } from 'lib/grid';
import AnalyticsCard from './AnalyticsCard';
import CardHeader from './CardHeader';
import GetStartedCard from './GetStartedCard';
import DashCard from '../DataSources/DashCard';
import { NavigationProps, ScreenName } from 'lib/types';

import './dashboard.css';
import einsteinHeader from './einstein-header.svg';
import AuthModal from '../DataSources/AuthModal';
import withBrand, { InjectedBrandProps } from 'lib/withBrand';
import NavContext from 'lib/NavContext';

const CommonPartners: React.SFC = () => (
	<Col className="dashboard_common-partners">
		<CardHeader
			icon="custom14"
			iconCategory="custom"
			title="Common Partners"
			subtext="Here are common partners that you can connect with"
		/>
		<Grid className="dashboard_common-partner slds-grid_vertical-align-center">
			<Col size="2-of-12"><img src="/assets/icons/loyaltyme-circle.svg" /></Col>
			<Col className="partner__name">LoyaltyMe</Col>
			<Col size="2-of-12"><Button label="Add" /></Col>
		</Grid>
		<Grid className="dashboard_common-partner slds-grid_vertical-align-center">
			<Col size="2-of-12"><img src="/assets/icons/conversion-catalyst-circle.svg" width="42px" /></Col>
			<Col className="partner__name">Amadeus</Col>
			<Col size="2-of-12"><Button label="Add" /></Col>
		</Grid>
	</Col>
);

const EinsteinCard: React.SFC = () => (
	<Col className="dashboard__einstein">
		<img src={einsteinHeader} />
		<h3>Einstein Recommendations</h3>
		<div className="dashboard__einstein-contents">
			<h4><strong>Connect Community Cloud</strong></h4>
			<p>Enable intelligent and branded communities and portals for customers and partners.</p>
			<Button label="Get Started" />
		</div>
	</Col>
);

interface DashboardProps extends InjectedBrandProps, NavigationProps {
	auth?: boolean;
	nav: ScreenName;
}
const Dashboard: React.SFC<DashboardProps> = ({ auth, brand, nav, navClick }) => {
	let configured: boolean, einstein;
	if (brand.dashboard) {
		configured = brand.dashboard.configured;
		einstein = brand.dashboard.einstein;
	} else { // Dashboard is usually configured, so default it to true if not specificed in the brand
		configured = true;
		einstein = true;
	}
	return (
		<Grid className={classnames('dashboard', {configured})}>
			<Col className="dashboard__main-card" size="7-of-12">
				<NavContext.Consumer>
					{navFunctions => (
						<DashCard configured={configured} navFunctions={navFunctions} screen={nav} />
					)}
				</NavContext.Consumer>
			</Col>
			<Col>
				<Grid vertical>
				{ configured ? 
					<AnalyticsCard screen={nav} /> :
					<GetStartedCard navClick={navClick} /> }
				{ configured ? 
					(einstein ? <EinsteinCard /> : null) :
					<CommonPartners /> }
				</Grid>
			</Col>
			{auth ? <AuthModal navClick={navClick} /> : null}
		</Grid>
	);
};

export default withBrand(Dashboard);


// WEBPACK FOOTER //
// ./src/Dashboard/index.tsx